// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
! tailwindcss v3.4.15 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

html,
  body {
    margin: 0;
    min-height: 100%;
    font-family: "Rubik", "Helvetica Neue", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: #F2F2F2;
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

html::-webkit-scrollbar,
  body::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }

svg {
    display: inline !important;
}

code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
      monospace;
  }
.container{
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
@media (min-width: 1584px){

  .container{
    max-width: 1584px;
  }
}
.pointer-events-none{
  pointer-events: none;
}
.visible{
  visibility: visible;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.inset-0{
  inset: 0px;
}
.bottom-0{
  bottom: 0px;
}
.left-0{
  left: 0px;
}
.left-1\\/2{
  left: 50%;
}
.right-0{
  right: 0px;
}
.right-3{
  right: 0.75rem;
}
.right-4{
  right: 1rem;
}
.top-0{
  top: 0px;
}
.top-1\\/2{
  top: 50%;
}
.top-14{
  top: 3.5rem;
}
.top-4{
  top: 1rem;
}
.top-\\[90px\\]{
  top: 90px;
}
.top-full{
  top: 100%;
}
.z-10{
  z-index: 10;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[60\\]{
  z-index: 60;
}
.z-\\[9999\\]{
  z-index: 9999;
}
.m-1{
  margin: 0.25rem;
}
.m-2{
  margin: 0.5rem;
}
.m-3{
  margin: 0.75rem;
}
.m-4{
  margin: 1rem;
}
.m-auto{
  margin: auto;
}
.mx-1{
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-2{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-4{
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-5{
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-6{
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-\\[15\\%\\]{
  margin-top: 15%;
  margin-bottom: 15%;
}
.my-\\[5\\%\\]{
  margin-top: 5%;
  margin-bottom: 5%;
}
.my-auto{
  margin-top: auto;
  margin-bottom: auto;
}
.mb-0\\.5{
  margin-bottom: 0.125rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-1\\.5{
  margin-bottom: 0.375rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.mb-\\[-150px\\]{
  margin-bottom: -150px;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-5{
  margin-left: 1.25rem;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-2\\.5{
  margin-right: 0.625rem;
}
.mr-4{
  margin-right: 1rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-40{
  margin-top: 10rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-\\[-40px\\]{
  margin-top: -40px;
}
.mt-\\[15px\\]{
  margin-top: 15px;
}
.mt-\\[20px\\]{
  margin-top: 20px;
}
.box-border{
  box-sizing: border-box;
}
.block{
  display: block;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.table-footer-group{
  display: table-footer-group;
}
.table-header-group{
  display: table-header-group;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.h-0{
  height: 0px;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-12{
  height: 3rem;
}
.h-24{
  height: 6rem;
}
.h-3{
  height: 0.75rem;
}
.h-4{
  height: 1rem;
}
.h-5{
  height: 1.25rem;
}
.h-60{
  height: 15rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-\\[100\\%\\]{
  height: 100%;
}
.h-\\[10px\\]{
  height: 10px;
}
.h-\\[110px\\]{
  height: 110px;
}
.h-\\[120px\\]{
  height: 120px;
}
.h-\\[200px\\]{
  height: 200px;
}
.h-\\[20px\\]{
  height: 20px;
}
.h-\\[24px\\]{
  height: 24px;
}
.h-\\[300px\\]{
  height: 300px;
}
.h-\\[30px\\]{
  height: 30px;
}
.h-\\[32px\\]{
  height: 32px;
}
.h-\\[350px\\]{
  height: 350px;
}
.h-\\[37px\\]{
  height: 37px;
}
.h-\\[38px\\]{
  height: 38px;
}
.h-\\[3px\\]{
  height: 3px;
}
.h-\\[40px\\]{
  height: 40px;
}
.h-\\[44px\\]{
  height: 44px;
}
.h-\\[48px\\]{
  height: 48px;
}
.h-\\[49px\\]{
  height: 49px;
}
.h-\\[50\\%\\]{
  height: 50%;
}
.h-\\[50px\\]{
  height: 50px;
}
.h-\\[55px\\]{
  height: 55px;
}
.h-\\[5px\\]{
  height: 5px;
}
.h-\\[60px\\]{
  height: 60px;
}
.h-\\[62px\\]{
  height: 62px;
}
.h-\\[64px\\]{
  height: 64px;
}
.h-\\[70\\%\\]{
  height: 70%;
}
.h-\\[70px\\]{
  height: 70px;
}
.h-\\[75px\\]{
  height: 75px;
}
.h-\\[80px\\]{
  height: 80px;
}
.h-\\[80vh\\]{
  height: 80vh;
}
.h-\\[90\\%\\]{
  height: 90%;
}
.h-auto{
  height: auto;
}
.h-full{
  height: 100%;
}
.max-h-\\[80vh\\]{
  max-height: 80vh;
}
.max-h-\\[85vh\\]{
  max-height: 85vh;
}
.min-h-\\[44px\\]{
  min-height: 44px;
}
.w-0{
  width: 0px;
}
.w-1\\.5{
  width: 0.375rem;
}
.w-1\\/4{
  width: 25%;
}
.w-24{
  width: 6rem;
}
.w-4{
  width: 1rem;
}
.w-48{
  width: 12rem;
}
.w-5{
  width: 1.25rem;
}
.w-64{
  width: 16rem;
}
.w-8{
  width: 2rem;
}
.w-9{
  width: 2.25rem;
}
.w-\\[10\\%\\]{
  width: 10%;
}
.w-\\[10\\.1\\%\\]{
  width: 10.1%;
}
.w-\\[10\\.10\\%\\]{
  width: 10.10%;
}
.w-\\[10\\.25\\%\\]{
  width: 10.25%;
}
.w-\\[100\\%\\]{
  width: 100%;
}
.w-\\[10px\\]{
  width: 10px;
}
.w-\\[11\\%\\]{
  width: 11%;
}
.w-\\[11\\.36\\%\\]{
  width: 11.36%;
}
.w-\\[11\\.45\\%\\]{
  width: 11.45%;
}
.w-\\[11\\.6\\%\\]{
  width: 11.6%;
}
.w-\\[1104px\\]{
  width: 1104px;
}
.w-\\[112px\\]{
  width: 112px;
}
.w-\\[12\\%\\]{
  width: 12%;
}
.w-\\[120px\\]{
  width: 120px;
}
.w-\\[13\\%\\]{
  width: 13%;
}
.w-\\[13\\.1\\%\\]{
  width: 13.1%;
}
.w-\\[1300px\\]{
  width: 1300px;
}
.w-\\[136px\\]{
  width: 136px;
}
.w-\\[14\\%\\]{
  width: 14%;
}
.w-\\[16\\%\\]{
  width: 16%;
}
.w-\\[16\\.41\\%\\]{
  width: 16.41%;
}
.w-\\[160px\\]{
  width: 160px;
}
.w-\\[16px\\]{
  width: 16px;
}
.w-\\[17\\%\\]{
  width: 17%;
}
.w-\\[17\\.2\\%\\]{
  width: 17.2%;
}
.w-\\[18\\%\\]{
  width: 18%;
}
.w-\\[19\\%\\]{
  width: 19%;
}
.w-\\[19\\.19\\%\\]{
  width: 19.19%;
}
.w-\\[19\\.2\\%\\]{
  width: 19.2%;
}
.w-\\[20\\%\\]{
  width: 20%;
}
.w-\\[20\\.8\\%\\]{
  width: 20.8%;
}
.w-\\[200px\\]{
  width: 200px;
}
.w-\\[20px\\]{
  width: 20px;
}
.w-\\[216px\\]{
  width: 216px;
}
.w-\\[22\\%\\]{
  width: 22%;
}
.w-\\[23\\%\\]{
  width: 23%;
}
.w-\\[24\\%\\]{
  width: 24%;
}
.w-\\[24px\\]{
  width: 24px;
}
.w-\\[25\\%\\]{
  width: 25%;
}
.w-\\[250px\\]{
  width: 250px;
}
.w-\\[26\\%\\]{
  width: 26%;
}
.w-\\[26px\\]{
  width: 26px;
}
.w-\\[27\\%\\]{
  width: 27%;
}
.w-\\[28\\%\\]{
  width: 28%;
}
.w-\\[28\\.22\\%\\]{
  width: 28.22%;
}
.w-\\[280px\\]{
  width: 280px;
}
.w-\\[29\\%\\]{
  width: 29%;
}
.w-\\[2px\\]{
  width: 2px;
}
.w-\\[30\\%\\]{
  width: 30%;
}
.w-\\[304px\\]{
  width: 304px;
}
.w-\\[30px\\]{
  width: 30px;
}
.w-\\[31\\.57\\%\\]{
  width: 31.57%;
}
.w-\\[32\\%\\]{
  width: 32%;
}
.w-\\[32\\.58\\%\\]{
  width: 32.58%;
}
.w-\\[33\\%\\]{
  width: 33%;
}
.w-\\[34\\%\\]{
  width: 34%;
}
.w-\\[35\\%\\]{
  width: 35%;
}
.w-\\[350px\\]{
  width: 350px;
}
.w-\\[384px\\]{
  width: 384px;
}
.w-\\[388px\\]{
  width: 388px;
}
.w-\\[4\\%\\]{
  width: 4%;
}
.w-\\[40\\%\\]{
  width: 40%;
}
.w-\\[40px\\]{
  width: 40px;
}
.w-\\[41\\%\\]{
  width: 41%;
}
.w-\\[43\\%\\]{
  width: 43%;
}
.w-\\[48\\%\\]{
  width: 48%;
}
.w-\\[48\\.48\\%\\]{
  width: 48.48%;
}
.w-\\[49px\\]{
  width: 49px;
}
.w-\\[5\\%\\]{
  width: 5%;
}
.w-\\[50px\\]{
  width: 50px;
}
.w-\\[51\\.52\\%\\]{
  width: 51.52%;
}
.w-\\[51px\\]{
  width: 51px;
}
.w-\\[527px\\]{
  width: 527px;
}
.w-\\[55\\%\\]{
  width: 55%;
}
.w-\\[55px\\]{
  width: 55px;
}
.w-\\[600px\\]{
  width: 600px;
}
.w-\\[60px\\]{
  width: 60px;
}
.w-\\[61\\%\\]{
  width: 61%;
}
.w-\\[62\\%\\]{
  width: 62%;
}
.w-\\[65\\%\\]{
  width: 65%;
}
.w-\\[68\\%\\]{
  width: 68%;
}
.w-\\[68\\.3\\%\\]{
  width: 68.3%;
}
.w-\\[68\\.9\\%\\]{
  width: 68.9%;
}
.w-\\[7\\%\\]{
  width: 7%;
}
.w-\\[72px\\]{
  width: 72px;
}
.w-\\[76\\%\\]{
  width: 76%;
}
.w-\\[77\\%\\]{
  width: 77%;
}
.w-\\[8\\%\\]{
  width: 8%;
}
.w-\\[80\\%\\]{
  width: 80%;
}
.w-\\[80px\\]{
  width: 80px;
}
.w-\\[89\\%\\]{
  width: 89%;
}
.w-\\[90\\%\\]{
  width: 90%;
}
.w-\\[95\\%\\]{
  width: 95%;
}
.w-\\[96px\\]{
  width: 96px;
}
.w-\\[97\\%\\]{
  width: 97%;
}
.w-\\[99\\%\\]{
  width: 99%;
}
.w-auto{
  width: auto;
}
.w-full{
  width: 100%;
}
.min-w-\\[120px\\]{
  min-width: 120px;
}
.min-w-\\[200px\\]{
  min-width: 200px;
}
.min-w-\\[260px\\]{
  min-width: 260px;
}
.min-w-\\[44px\\]{
  min-width: 44px;
}
.min-w-\\[48px\\]{
  min-width: 48px;
}
.min-w-full{
  min-width: 100%;
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-\\[1600px\\]{
  max-width: 1600px;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-sm{
  max-width: 24rem;
}
.flex-1{
  flex: 1 1;
}
.shrink-0{
  flex-shrink: 0;
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-\\[9px\\]{
  --tw-translate-y: -9px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-full{
  --tw-translate-y: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[1px\\]{
  --tw-translate-x: 1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full{
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[9px\\]{
  --tw-translate-y: 9px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-45{
  --tw-rotate: -45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45{
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse{

  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-pointer{
  cursor: pointer;
}
.appearance-none{
  appearance: none;
}
.grid-cols-7{
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.place-items-start{
  place-items: start;
}
.place-items-end{
  place-items: end;
}
.place-items-center{
  place-items: center;
}
.content-center{
  align-content: center;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-stretch{
  align-items: stretch;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.justify-around{
  justify-content: space-around;
}
.justify-evenly{
  justify-content: space-evenly;
}
.gap-1{
  gap: 0.25rem;
}
.gap-10{
  gap: 2.5rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-8{
  gap: 2rem;
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-\\[10px\\]{
  border-radius: 10px;
}
.rounded-\\[50\\%\\]{
  border-radius: 50%;
}
.rounded-\\[8px\\]{
  border-radius: 8px;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-sm{
  border-radius: 0.125rem;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-b-\\[8px\\]{
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}
.rounded-b-lg{
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-l-\\[10px\\]{
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.rounded-l-\\[8px\\]{
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.rounded-r-\\[10px\\]{
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.rounded-r-\\[8px\\]{
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
.rounded-t-lg{
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.rounded-t-xl{
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.border{
  border-width: 1px;
}
.border-2{
  border-width: 2px;
}
.border-\\[1\\.5px\\]{
  border-width: 1.5px;
}
.border-\\[1px\\]{
  border-width: 1px;
}
.border-\\[2px\\]{
  border-width: 2px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-b-\\[8px\\]{
  border-bottom-width: 8px;
}
.border-l-\\[8px\\]{
  border-left-width: 8px;
}
.border-r-2{
  border-right-width: 2px;
}
.border-r-\\[8px\\]{
  border-right-width: 8px;
}
.border-t{
  border-top-width: 1px;
}
.border-solid{
  border-style: solid;
}
.border-\\[\\#000000\\]{
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.border-\\[\\#739D00\\]{
  --tw-border-opacity: 1;
  border-color: rgb(115 157 0 / var(--tw-border-opacity, 1));
}
.border-\\[\\#B8B8B8\\]{
  --tw-border-opacity: 1;
  border-color: rgb(184 184 184 / var(--tw-border-opacity, 1));
}
.border-\\[\\#D9D9D9\\]{
  --tw-border-opacity: 1;
  border-color: rgb(217 217 217 / var(--tw-border-opacity, 1));
}
.border-\\[\\#FF3D00\\]{
  --tw-border-opacity: 1;
  border-color: rgb(255 61 0 / var(--tw-border-opacity, 1));
}
.border-\\[\\#FF6D00\\]{
  --tw-border-opacity: 1;
  border-color: rgb(255 109 0 / var(--tw-border-opacity, 1));
}
.border-\\[\\#dbdbdb\\]{
  --tw-border-opacity: 1;
  border-color: rgb(219 219 219 / var(--tw-border-opacity, 1));
}
.border-black{
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.border-gray-100{
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
.border-gray-200{
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-300{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-900{
  --tw-border-opacity: 1;
  border-color: rgb(17 24 39 / var(--tw-border-opacity, 1));
}
.border-white\\/10{
  border-color: rgb(255 255 255 / 0.1);
}
.border-white\\/30{
  border-color: rgb(255 255 255 / 0.3);
}
.border-b-\\[\\#739D00\\]{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(115 157 0 / var(--tw-border-opacity, 1));
}
.border-b-\\[\\#FF3D00\\]{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(255 61 0 / var(--tw-border-opacity, 1));
}
.border-l-transparent{
  border-left-color: transparent;
}
.border-r-transparent{
  border-right-color: transparent;
}
.bg-600d{
  --tw-bg-opacity: 1;
  background-color: rgb(255 211 161 / var(--tw-bg-opacity, 1));
}
.bg-SC{
  --tw-bg-opacity: 1;
  background-color: rgb(255 213 153 / var(--tw-bg-opacity, 1));
}
.bg-T2{
  --tw-bg-opacity: 1;
  background-color: rgb(136 153 159 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#00000073\\]{
  background-color: #00000073;
}
.bg-\\[\\#00599D\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(0 89 157 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0E0874\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(14 8 116 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0d0874a9\\]{
  background-color: #0d0874a9;
}
.bg-\\[\\#0d0874d0\\]{
  background-color: #0d0874d0;
}
.bg-\\[\\#739D00\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(115 157 0 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#B1F100\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(177 241 0 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#B8B8B8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(184 184 184 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#B9CE80\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(185 206 128 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#D9D9D9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(217 217 217 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F2F2F2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(242 242 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F4F4F4\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 244 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F5F8EB\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(245 248 235 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F9F9F9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(249 249 249 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FAFAFA\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FF3D00\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 61 0 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FF6D00\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 109 0 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFFFFF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#dbdbdb\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(219 219 219 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e6e6e6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(230 230 230 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ececec\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(236 236 236 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fd9a29\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(253 154 41 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ff0d0d3b\\]{
  background-color: #ff0d0d3b;
}
.bg-\\[\\#ffffff\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ffffffc4\\]{
  background-color: #ffffffc4;
}
.bg-backlit{
  --tw-bg-opacity: 1;
  background-color: rgb(179 178 255 / var(--tw-bg-opacity, 1));
}
.bg-black\\/40{
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/60{
  background-color: rgb(0 0 0 / 0.6);
}
.bg-blockout{
  --tw-bg-opacity: 1;
  background-color: rgb(245 205 232 / var(--tw-bg-opacity, 1));
}
.bg-blue-100{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-50{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-600{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-flag{
  --tw-bg-opacity: 1;
  background-color: rgb(154 220 225 / var(--tw-bg-opacity, 1));
}
.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-300{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.bg-gray-400{
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.bg-gray-50{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-gray-600{
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.bg-green-100{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-green-600{
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-reshet{
  --tw-bg-opacity: 1;
  background-color: rgb(255 236 122 / var(--tw-bg-opacity, 1));
}
.bg-strech{
  --tw-bg-opacity: 1;
  background-color: rgb(156 230 191 / var(--tw-bg-opacity, 1));
}
.bg-tension{
  --tw-bg-opacity: 1;
  background-color: rgb(255 200 200 / var(--tw-bg-opacity, 1));
}
.bg-transparent{
  background-color: transparent;
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10{
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/5{
  background-color: rgb(255 255 255 / 0.05);
}
.bg-white\\/50{
  background-color: rgb(255 255 255 / 0.5);
}
.bg-white\\/60{
  background-color: rgb(255 255 255 / 0.6);
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-blue-50{
  --tw-gradient-from: #eff6ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 246 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-50\\/50{
  --tw-gradient-from: rgb(239 246 255 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 246 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-indigo-50{
  --tw-gradient-to: #eef2ff var(--tw-gradient-to-position);
}
.to-indigo-50\\/50{
  --tw-gradient-to: rgb(238 242 255 / 0.5) var(--tw-gradient-to-position);
}
.stroke-\\[\\#9c9a9a\\]{
  stroke: #9c9a9a;
}
.object-cover{
  object-fit: cover;
}
.p-0{
  padding: 0px;
}
.p-1{
  padding: 0.25rem;
}
.p-2{
  padding: 0.5rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.px-0\\.5{
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-\\[15px\\]{
  padding-left: 15px;
  padding-right: 15px;
}
.px-\\[24px\\]{
  padding-left: 24px;
  padding-right: 24px;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-\\[15px\\]{
  padding-top: 15px;
  padding-bottom: 15px;
}
.pb-10{
  padding-bottom: 2.5rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-5{
  padding-bottom: 1.25rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-4{
  padding-right: 1rem;
}
.pt-24{
  padding-top: 6rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.text-start{
  text-align: start;
}
.align-middle{
  vertical-align: middle;
}
.font-rubik{
  font-family: Rubik, sans-serif;
}
.font-sans{
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-6xl{
  font-size: 3.75rem;
  line-height: 1;
}
.text-\\[1\\.6vw\\]{
  font-size: 1.6vw;
}
.text-\\[1\\.8vw\\]{
  font-size: 1.8vw;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[14px\\]{
  font-size: 14px;
}
.text-\\[16px\\]{
  font-size: 16px;
}
.text-\\[18px\\]{
  font-size: 18px;
}
.text-\\[1vw\\]{
  font-size: 1vw;
}
.text-\\[2\\.2vw\\]{
  font-size: 2.2vw;
}
.text-\\[2\\.3vw\\]{
  font-size: 2.3vw;
}
.text-\\[2\\.5vw\\]{
  font-size: 2.5vw;
}
.text-\\[2\\.8vw\\]{
  font-size: 2.8vw;
}
.text-\\[20px\\]{
  font-size: 20px;
}
.text-\\[25px\\]{
  font-size: 25px;
}
.text-\\[2vw\\]{
  font-size: 2vw;
}
.text-\\[30px\\]{
  font-size: 30px;
}
.text-\\[40px\\]{
  font-size: 40px;
}
.text-\\[clamp\\(10px\\2c 1\\.2vw\\2c 16px\\)\\]{
  font-size: clamp(10px,1.2vw,16px);
}
.text-\\[clamp\\(16px\\2c 1\\.5vw\\2c 20px\\)\\]{
  font-size: clamp(16px,1.5vw,20px);
}
.text-\\[clamp\\(18px\\2c 1\\.8vw\\2c 24px\\)\\]{
  font-size: clamp(18px,1.8vw,24px);
}
.text-\\[clamp\\(20px\\2c 3vw\\2c 40px\\)\\]{
  font-size: clamp(20px,3vw,40px);
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-\\[24px\\]{
  font-weight: 24px;
}
.font-black{
  font-weight: 900;
}
.font-bold{
  font-weight: 700;
}
.font-extrabold{
  font-weight: 800;
}
.font-light{
  font-weight: 300;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.leading-\\[100\\%\\]{
  line-height: 100%;
}
.leading-none{
  line-height: 1;
}
.leading-normal{
  line-height: 1.5;
}
.leading-tight{
  line-height: 1;
}
.tracking-\\[0\\.05em\\]{
  letter-spacing: 0.05em;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-wide-5{
  letter-spacing: 0.05em;
}
.text-\\[\\#53626B\\]{
  --tw-text-opacity: 1;
  color: rgb(83 98 107 / var(--tw-text-opacity, 1));
}
.text-\\[\\#65ADE3\\]{
  --tw-text-opacity: 1;
  color: rgb(101 173 227 / var(--tw-text-opacity, 1));
}
.text-\\[\\#707070\\]{
  --tw-text-opacity: 1;
  color: rgb(112 112 112 / var(--tw-text-opacity, 1));
}
.text-\\[\\#739D00\\]{
  --tw-text-opacity: 1;
  color: rgb(115 157 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#7D7D7D\\]{
  --tw-text-opacity: 1;
  color: rgb(125 125 125 / var(--tw-text-opacity, 1));
}
.text-\\[\\#979797\\]{
  --tw-text-opacity: 1;
  color: rgb(151 151 151 / var(--tw-text-opacity, 1));
}
.text-\\[\\#9E9E9E\\]{
  --tw-text-opacity: 1;
  color: rgb(158 158 158 / var(--tw-text-opacity, 1));
}
.text-\\[\\#ACCF49\\]{
  --tw-text-opacity: 1;
  color: rgb(172 207 73 / var(--tw-text-opacity, 1));
}
.text-\\[\\#D2E3A4\\]{
  --tw-text-opacity: 1;
  color: rgb(210 227 164 / var(--tw-text-opacity, 1));
}
.text-\\[\\#D9D9D9\\]{
  --tw-text-opacity: 1;
  color: rgb(217 217 217 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F2F2F2\\]{
  --tw-text-opacity: 1;
  color: rgb(242 242 242 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FF6D00\\]{
  --tw-text-opacity: 1;
  color: rgb(255 109 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FFFFFF\\]{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-\\[\\#dbdbdb\\]{
  --tw-text-opacity: 1;
  color: rgb(219 219 219 / var(--tw-text-opacity, 1));
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-500{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-gray-400{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-800{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-orange-500{
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity, 1));
}
.text-purple-500{
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity, 1));
}
.text-transparent{
  color: transparent;
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-yellow-500{
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity, 1));
}
.underline{
  text-decoration-line: underline;
}
.line-through{
  text-decoration-line: line-through;
}
.antialiased{
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.opacity-0{
  opacity: 0;
}
.opacity-50{
  opacity: 0.5;
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-blue-500\\/30{
  --tw-shadow-color: rgb(59 130 246 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.ring-4{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-white{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-md{
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

@media print {
  @page {
    size: A4 portrait;
    margin: 5mm;
  }

  * {
    print-color-adjust: exact !important;
  }
  
  html, body {
    width: 100% !important;
    height: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    background: white !important;
  }
  
  body * {
    visibility: hidden !important;
  }
  
  .show-order-overlay,
  .show-order-overlay * {
    visibility: visible !important;
  }
  
  .show-order-overlay {
    position: absolute !important;
    left: 0 !important;
    top: 0 !important;
    width: 100% !important;
    height: auto !important;
    background: white !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  
  .show-order-modal {
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    margin: 0 !important;
    padding: 0 !important;
    background: white !important;
    box-shadow: none !important;
    border-radius: 0 !important;
  }
  
  .print-content {
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    overflow: visible !important;
    font-size: 10px !important;
    line-height: 1.2 !important;
  }
  
  .print-content table {
    width: 100% !important;
    border-collapse: collapse !important;
    table-layout: fixed !important;
  }
  
  .print-content thead {
    display: table-header-group !important;
  }
  
  .print-content tbody {
    display: table-row-group !important;
  }
  
  .print-content tr {
    page-break-inside: avoid !important;
  }
  
  .print-content td,
  .print-content th {
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
  }
  
  .print-content img {
    max-width: 100% !important;
    height: auto !important;
    display: block !important;
  }
  
  .print-content p,
  .print-content div,
  .print-content span {
    max-width: 100% !important;
    word-wrap: break-word !important;
  }
  
  .print-content * {
    margin: 0 !important;
    padding: 2px !important;
  }
  
  .print-content h1,
  .print-content h2,
  .print-content h3,
  .print-content h4,
  .print-content h5,
  .print-content h6 {
    page-break-after: avoid !important;
    margin: 0 !important;
    padding: 2px 0 !important;
  }
  
  .print-content br:last-of-type,
  .print-content div:empty,
  .print-content p:empty {
    display: none !important;
  }
  
  .print-content > * {
    max-height: none !important;
  }
  
  .no-print,
  button {
    display: none !important;
    visibility: hidden !important;
  }
}

@media screen {
  .show-order-overlay {
    overflow-y: auto !important;
  }
}

@keyframes pulse-red {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

/* Скрыть скроллбар, но оставить возможность прокрутки */
html.no-scrollbar,
body.no-scrollbar,
.no-scrollbar {
  -ms-overflow-style: none !important;
  scrollbar-width: none !important;
}
html.no-scrollbar::-webkit-scrollbar,
body.no-scrollbar::-webkit-scrollbar,
.no-scrollbar::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}
.placeholder\\:text-gray-700::placeholder{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.hover\\:-translate-y-0\\.5:hover{
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-110:hover{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:border-\\[\\#739D00\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(115 157 0 / var(--tw-border-opacity, 1));
}
.hover\\:bg-\\[\\#5a7a00\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(90 122 0 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#5a7d00\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(90 125 0 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#638500\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(99 133 0 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#739D00\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(115 157 0 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#ACCF49\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(172 207 73 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#B9CE80\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(185 206 128 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#FF3D00\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 61 0 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#e6e6e6\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(230 230 230 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#f2f2f2\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(242 242 242 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-200\\/50:hover{
  background-color: rgb(229 231 235 / 0.5);
}
.hover\\:bg-gray-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-sky-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(186 230 253 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.hover\\:text-\\[\\#739D00\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(115 157 0 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#739d00a8\\]:hover{
  color: #739d00a8;
}
.hover\\:text-black:hover{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-600:hover{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-700:hover{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.hover\\:opacity-50:hover{
  opacity: 0.5;
}
.hover\\:opacity-70:hover{
  opacity: 0.7;
}
.hover\\:opacity-80:hover{
  opacity: 0.8;
}
.hover\\:opacity-90:hover{
  opacity: 0.9;
}
.hover\\:shadow-md:hover{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:border-\\[\\#739D00\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(115 157 0 / var(--tw-border-opacity, 1));
}
.focus\\:border-\\[\\#FF3D00\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(255 61 0 / var(--tw-border-opacity, 1));
}
.focus\\:border-blue-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.focus\\:bg-white:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-\\[\\#739D00\\]:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(115 157 0 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-blue-500\\/20:focus{
  --tw-ring-color: rgb(59 130 246 / 0.2);
}
.active\\:scale-\\[0\\.98\\]:active{
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:bg-\\[\\#739d00a8\\]{
  background-color: #739d00a8;
}
@media (min-width: 1024px){

  .lg\\:flex{
    display: flex;
  }

  .lg\\:text-\\[15px\\]{
    font-size: 15px;
  }

  .lg\\:text-\\[30px\\]{
    font-size: 30px;
  }

  .lg\\:text-\\[38px\\]{
    font-size: 38px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;IAAA,SAAc;IAAd,gBAAc;IAAd,kDAAc;IAAd,mCAAc;IAAd,kCAAc;IAAd,yBAAc;IAAd,gBAAc;IAAd,wBAAc;IAAd,qBAAc;EAAA;;AAAd;;IAAA,aAAc;IAAd,QAAc;IAAd,SAAc;EAAA;;AAAd;IAAA,0BAAc;AAAA;;AAAd;IAAA;eAAc;EAAA;AACd;EAAA,WAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AA8BnB;EACE;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IAEE,oCAAoC;EACtC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;IAC7B,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,4BAA4B;IAC5B,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,oCAAoC;IACpC,8BAA8B;EAChC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,mCAAmC;EACrC;;EAEA;;IAEE,gCAAgC;IAChC,oCAAoC;EACtC;;EAEA;IACE,0BAA0B;IAC1B,uBAAuB;IACvB,yBAAyB;EAC3B;;EAEA;;;IAGE,0BAA0B;IAC1B,gCAAgC;EAClC;;EAEA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;;EAEA;;;;;;IAME,kCAAkC;IAClC,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA;;;IAGE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,wBAAwB;IACxB,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,wDAAwD;AACxD;;;EAGE,mCAAmC;EACnC,gCAAgC;AAClC;AACA;;;EAGE,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;AACtB;AAlMA;EAAA,oBAmMA;EAnMA;AAmMA;AAnMA;EAAA,2BAmMA;EAnMA;AAmMA;AAnMA;EAAA,iBAmMA;EAnMA,iBAmMA;EAnMA;AAmMA;AAnMA;EAAA,sBAmMA;EAnMA;AAmMA;AAnMA;EAAA,kBAmMA;EAnMA;AAmMA;AAnMA;EAAA,kBAmMA;EAnMA;AAmMA;AAnMA;EAAA,kBAmMA;EAnMA;AAmMA;AAnMA;EAAA,kBAmMA;EAnMA;AAmMA;AAnMA;EAAA,kBAmMA;EAnMA;AAmMA;AAnMA;EAAA,kBAmMA;EAnMA;AAmMA;AAnMA;EAAA,kBAmMA;EAnMA;AAmMA;AAnMA;EAAA,kBAmMA;EAnMA;AAmMA;AAnMA;EAAA,kBAmMA;EAnMA;AAmMA;AAnMA;EAAA,kBAmMA;EAnMA;AAmMA;AAnMA;EAAA,kBAmMA;EAnMA;AAmMA;AAnMA;EAAA,kBAmMA;EAnMA;AAmMA;AAnMA;EAAA;AAmMA;AAnMA;EAAA,kBAmMA;EAnMA;AAmMA;AAnMA;EAAA,kBAmMA;EAnMA;AAmMA;AAnMA;EAAA,kBAmMA;EAnMA;AAmMA;AAnMA;EAAA,kBAmMA;EAnMA;AAmMA;AAnMA;EAAA,oBAmMA;EAnMA;AAmMA;AAnMA;EAAA;AAmMA;AAnMA;EAAA,oBAmMA;EAnMA;AAmMA;AAnMA;EAAA,oBAmMA;EAnMA;AAmMA;AAnMA;EAAA,oBAmMA;EAnMA;AAmMA;AAnMA;EAAA,oBAmMA;EAnMA;AAmMA;AAnMA;EAAA;AAmMA;AAnMA;EAAA;AAmMA;AAnMA;EAAA;AAmMA;AAnMA;EAAA;AAmMA;AAnMA;EAAA,6EAmMA;EAnMA,iGAmMA;EAnMA;AAmMA;AAnMA;EAAA,sBAmMA;EAnMA;AAmMA;AAnMA;EAAA,sBAmMA;EAnMA;AAmMA;AAnMA;EAAA,sBAmMA;EAnMA;AAmMA;AAnMA;EAAA,kBAmMA;EAnMA;AAmMA;AAnMA;EAAA,8BAmMA;EAnMA;AAmMA;AAnMA;EAAA,2GAmMA;EAnMA,yGAmMA;EAnMA;AAmMA;AAnMA;EAAA,oBAmMA;EAnMA;AAmMA;AAnMA;EAAA;AAmMA;AAnMA;EAAA,kBAmMA;EAnMA,kBAmMA;EAnMA;AAmMA;AAnMA;EAAA;AAmMA;AAnMA;;EAAA;IAAA;EAmMA;;EAnMA;IAAA;EAmMA;;EAnMA;IAAA;EAmMA;;EAnMA;IAAA;EAmMA;AAAA","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;600;700;800;900&display=swap');\r\n\r\n@tailwind base;\r\n@tailwind components;\r\n@tailwind utilities;\r\n@layer base {\r\n  html,\r\n  body {\r\n    margin: 0;\r\n    min-height: 100%;\r\n    font-family: \"Rubik\", \"Helvetica Neue\", sans-serif;\r\n    -webkit-font-smoothing: antialiased;\r\n    -moz-osx-font-smoothing: grayscale;\r\n    background-color: #F2F2F2;\r\n    overflow-y: auto;\r\n    -ms-overflow-style: none;\r\n    scrollbar-width: none;\r\n  }\r\n  html::-webkit-scrollbar,\r\n  body::-webkit-scrollbar {\r\n    display: none;\r\n    width: 0;\r\n    height: 0;\r\n  }\r\n  svg {\r\n    display: inline !important;\r\n}\r\n\r\n  code {\r\n    font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\r\n      monospace;\r\n  }\r\n}\r\n\r\n@media print {\r\n  @page {\r\n    size: A4 portrait;\r\n    margin: 5mm;\r\n  }\r\n\r\n  * {\r\n    -webkit-print-color-adjust: exact !important;\r\n    print-color-adjust: exact !important;\r\n  }\r\n  \r\n  html, body {\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n    margin: 0 !important;\r\n    padding: 0 !important;\r\n    background: white !important;\r\n  }\r\n  \r\n  body * {\r\n    visibility: hidden !important;\r\n  }\r\n  \r\n  .show-order-overlay,\r\n  .show-order-overlay * {\r\n    visibility: visible !important;\r\n  }\r\n  \r\n  .show-order-overlay {\r\n    position: absolute !important;\r\n    left: 0 !important;\r\n    top: 0 !important;\r\n    width: 100% !important;\r\n    height: auto !important;\r\n    background: white !important;\r\n    margin: 0 !important;\r\n    padding: 0 !important;\r\n  }\r\n  \r\n  .show-order-modal {\r\n    width: 100% !important;\r\n    max-width: 100% !important;\r\n    height: auto !important;\r\n    margin: 0 !important;\r\n    padding: 0 !important;\r\n    background: white !important;\r\n    box-shadow: none !important;\r\n    border-radius: 0 !important;\r\n  }\r\n  \r\n  .print-content {\r\n    width: 100% !important;\r\n    max-width: 100% !important;\r\n    height: auto !important;\r\n    overflow: visible !important;\r\n    font-size: 10px !important;\r\n    line-height: 1.2 !important;\r\n  }\r\n  \r\n  .print-content table {\r\n    width: 100% !important;\r\n    border-collapse: collapse !important;\r\n    table-layout: fixed !important;\r\n  }\r\n  \r\n  .print-content thead {\r\n    display: table-header-group !important;\r\n  }\r\n  \r\n  .print-content tbody {\r\n    display: table-row-group !important;\r\n  }\r\n  \r\n  .print-content tr {\r\n    page-break-inside: avoid !important;\r\n  }\r\n  \r\n  .print-content td,\r\n  .print-content th {\r\n    word-wrap: break-word !important;\r\n    overflow-wrap: break-word !important;\r\n  }\r\n  \r\n  .print-content img {\r\n    max-width: 100% !important;\r\n    height: auto !important;\r\n    display: block !important;\r\n  }\r\n  \r\n  .print-content p,\r\n  .print-content div,\r\n  .print-content span {\r\n    max-width: 100% !important;\r\n    word-wrap: break-word !important;\r\n  }\r\n  \r\n  .print-content * {\r\n    margin: 0 !important;\r\n    padding: 2px !important;\r\n  }\r\n  \r\n  .print-content h1,\r\n  .print-content h2,\r\n  .print-content h3,\r\n  .print-content h4,\r\n  .print-content h5,\r\n  .print-content h6 {\r\n    page-break-after: avoid !important;\r\n    margin: 0 !important;\r\n    padding: 2px 0 !important;\r\n  }\r\n  \r\n  .print-content br:last-of-type,\r\n  .print-content div:empty,\r\n  .print-content p:empty {\r\n    display: none !important;\r\n  }\r\n  \r\n  .print-content > * {\r\n    max-height: none !important;\r\n  }\r\n  \r\n  .no-print,\r\n  button {\r\n    display: none !important;\r\n    visibility: hidden !important;\r\n  }\r\n}\r\n\r\n@media screen {\r\n  .show-order-overlay {\r\n    overflow-y: auto !important;\r\n  }\r\n}\r\n\r\n@keyframes pulse-red {\r\n  0% {\r\n    background-position: 0% 50%;\r\n  }\r\n  50% {\r\n    background-position: 100% 50%;\r\n  }\r\n  100% {\r\n    background-position: 0% 50%;\r\n  }\r\n}\r\n\r\n/* Скрыть скроллбар, но оставить возможность прокрутки */\r\nhtml.no-scrollbar,\r\nbody.no-scrollbar,\r\n.no-scrollbar {\r\n  -ms-overflow-style: none !important;\r\n  scrollbar-width: none !important;\r\n}\r\nhtml.no-scrollbar::-webkit-scrollbar,\r\nbody.no-scrollbar::-webkit-scrollbar,\r\n.no-scrollbar::-webkit-scrollbar {\r\n  display: none !important;\r\n  width: 0 !important;\r\n  height: 0 !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
